import React from 'react';
import './style.css';
import {
  BsFillArchiveFill,
  BsFillGrid3X3GapFill,
  BsPeopleFill,
  BsFillBellFill,
  BsFillPatchCheckFill
} from 'react-icons/bs';

import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const cardsData = [
  {
    icon: <BsFillArchiveFill className="card_icon" />,
    title: 'Estudantes',
    value: 19,
    description: 'Detalhes sobre estudantes',
    color: '#9acd32',
  },
  {
    icon: <BsFillGrid3X3GapFill className="card_icon" />,
    title: 'Artigos',
    value: 3,
    description: 'Detalhes sobre artigos',
    color: '#ffbb28',
  },
  {
    icon: <BsPeopleFill className="card_icon" />,
    title: 'Times',
    value: 3,
    description: 'Detalhes sobre times',
    color: '#008000',
  },
  {
    icon: <BsFillBellFill className="card_icon" />,
    title: 'Cursos',
    value: 42,
    description: 'Detalhes sobre cursos',
    color: '#ff8042',
  },
  {
    icon: <BsFillPatchCheckFill className="card_icon" />,
    title: 'Ações Afirmativas',
    value: 42,
    description: 'Ações afirmativas',
    color: '#d9534f',
  }
];

const createPieData = (value) => [
  { name: 'Preenchido', value },
  { name: 'Vazio', value: 100 - value },
];

const RADIAN = Math.PI / 180;

function renderCustomizedLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#333"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={14}
      fontWeight="600"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
}

function Cards() {
  return (
    <>
      <div className="main-cards">
        {cardsData.map((card, index) => {
          const pieData = createPieData(card.value);
          return (
            <div className="card" key={index}>
              <div className="card-top">
                <div className="card-title-left">
                  {card.icon}
                  <span className="card-title">{card.title}</span>
                </div>
                <span className="card-value">{card.value}</span>
              </div>

              <div className="card-bottom">
                <div className="card-description">
                  <p>{card.description}</p>
                </div>
                <div className="chart-container">
                  <ResponsiveContainer width={80} height={80}>
                    <PieChart>
                      <Pie
                        data={pieData}
                        innerRadius={30}
                        outerRadius={40}
                        dataKey="value"
                        startAngle={90}
                        endAngle={-270}
                      >
                        {pieData.map((entry, idx) => (
                          <Cell
                            key={`cell-${idx}`}
                            fill={idx === 0 ? card.color : '#e0e0e0'}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Cards;
